import { render, staticRenderFns } from "./PayorAdmin.vue?vue&type=template&id=a73b318a&"
import script from "./PayorAdmin.vue?vue&type=script&lang=js&"
export * from "./PayorAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports